<template>
  <ul class="menu-list " style="margin-top: 60px">
    <li class="menu-item">
      <div class="border" v-on:click="sel == 1 ? sel = 0 : sel = 1">NLU Features
        <span style="float: right; margin-right:15px">
          <i class="fas fa-angle-down"></i>
        </span>
      </div>
      <ul v-show="sel == 1" class="pad-none margin-none">
        <li class="menu-item pad-none ">
          <a @click="intentHome()">
            <span class="icon-side-menu"><i class="far fa-comment-alt"></i></span>
            Intents</a>
        </li>
        <li class="menu-item pad-none ">
          <a @click="entityHome()">
            <span class="icon-side-menu"><i class="fas fa-sitemap"></i></span>Entities</a>
        </li>
      </ul>
    </li>
    <li class="menu-item">
      <div v-on:click="sel1 == 2 ? sel1 = 0 : sel1 = 2" class="border">NLU Performances
        <span  style="float: right; margin-right:15px">
          <i class="fas fa-angle-down"></i>
        </span>
      </div>
      <ul  v-show="sel1 == 2" class="pad-none margin-none">
        <li class="menu-item pad-none ">
          <a @click="ReviewHome()">
            <span class="icon-side-menu"><i class="fas fa-desktop"></i></span>Review endpoint</a>
        </li>
        <li class="menu-item pad-none ">
          <a :href="'/application/'+bot._id+'/dashboard/DetailedModelView'">
            <span class="icon-side-menu"><i class="fas fa-tachometer-alt"></i></span>
            Dashboard
          </a>
        </li>
      </ul>
    </li>
     <li class="menu-item">
      <div v-on:click="sel1 == 2 ? sel1 = 0 : sel1 = 2" class="border">Manage My App
        <span  style="float: right; margin-right:15px">
          <i class="fas fa-angle-down"></i>
        </span>
      </div>
      <ul  v-show="sel1 == 2" class="pad-none margin-none">
        <li class="menu-item pad-none ">
          <a @click="general()">
            <span class="icon-side-menu"><i class="fas fa-info-circle"></i></span>Application Information</a>
        </li>
        <li class="menu-item pad-none ">
          <a @click="endpoint()">
            <span class="icon-side-menu"><i class="fas fa-key"></i></span>
            Connect
          </a>
        </li>
      </ul>
    </li>
 
     <li class="menu-item border">
      <a class="border">
        Support
        <i class="fas fa-angle-down"></i>
      </a>
      <ul class="pad-none margin-none">
        <li class="menu-item pad-none ">
          <a @click="ticket()">Ticket </a>
        </li>
        <li class="menu-item pad-none ">
         <a @click="annoucements()">Annoucements</a>
        </li>
         
       
      </ul>
    </li>
  </ul>
</template>

<script>
import bulmaAccordion from "bulma-extensions/bulma-accordion/src/js/index.js";
export default {
  data(){
    return {
      sel: 1,
      sel1: 2,
    }
  },
  computed:{
    bot() {
      return this.$store.getters.getBot;
    },
  },
  methods: {
      ticket(){
      this.$router.replace({
      name: 'TicketComponent',
      append: true
    })
    },
     annoucements(){
        this.$router.replace({
      name: 'AnnoucementsComponent',
      append: true
    })
     },
     userGuid()  {
        this.$router.replace({
      name: 'UserGuidComponent',
      append: true
    })
     },
    
    general(){
    this.$router.replace({
      name: 'GeneralComponent',
      append: true
    })
  },
  endpoint(){
    this.$router.replace({
      name: 'EndPointComponent',
      append: true
    })
  },
    intentHome(){
      this.$router.replace({name: 'intentHome'})
    },
    ReviewHome(){
     this.$router.replace({name: 'ReviewHome'})

    },
    entityHome(){
      this.$router.replace({name: 'entityHome'})
    },
  },

};
</script>

<style scoped lang="sass">
.icon-side-menu
  margin-right: 15px
</style>



// WEBPACK FOOTER //
// src/components/Shared/Menu/components/side.menu.dashboard.component.vue